import { StatusColors } from '@nexelem/components';
import { TaskError, TaskStatus } from '@nexelem/graphne-api';
import { hasCriticalError } from './hasCriticalError';

const mapper: Record<TaskStatus, StatusColors> = {
  [TaskStatus.Completed]: 'green',
  [TaskStatus.Error]: 'red',
  [TaskStatus.InProgress]: 'blue',
  [TaskStatus.NotPlanned]: 'grey',
  [TaskStatus.Pending]: 'yellow',
  [TaskStatus.Cancelled]: 'grey',
  [TaskStatus.Hidden]: 'grey',
};

export const getTaskStatusColor = (color: TaskStatus, errors?: TaskError[]): StatusColors => {
  const criticalError = hasCriticalError(errors);

  return criticalError ? mapper.Error : mapper[color];
};
